function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Simple class to extend setInterval functionality. e.g. pausing an interval.
 */
var WDHCarouselTimer = /*#__PURE__*/function () {
  function WDHCarouselTimer() {
    _classCallCheck(this, WDHCarouselTimer);
    /**
     * The callback function to be called when timer/interval elapses
     * @private
     * @type {function}
     */
    this.callback = null;

    /**
     * The unique ID set by calling setInterval
     * @private
     * @type {number}
     */
    this.timerID = null;

    /**
     * The time the interval started, used when pausing an interval
     * @private
     * @type {number}
     */
    this.startTime = 0;

    /**
     * the currently set interval timing
     * defaults to 5 seconds.
     * @type {number}
     */
    this.currInterval = 5000;

    /**
     * holds the amount of time left in the interval before it was paused.
     * @type {number}
     */
    this.timeRemaining = 0;

    /**
     * lets us know if the timer is currently paused. Useful for scrolling events.
     * @type {boolean}
     */
    this.isPausedByScroll = false;

    /**
     * lets us know if the timer is currently paused by hover
     * @type {boolean}
     */
    this.isPausedByHover = false;
  }

  /**
   * initializes the timer by setting the callback function
   * @param callback
   */
  return _createClass(WDHCarouselTimer, [{
    key: "init",
    value: function init(callback) {
      this.callback = callback;
    }

    /**
     * start the interval timer
     */
  }, {
    key: "startInterval",
    value: function startInterval() {
      var _this = this;
      this.startTime = Date.now();
      this.stopInterval(); // prevent button bounce.  ensures all previous timers are clear before starting a new one.
      this.timerID = window.setInterval(function () {
        _this.startTime = Date.now();
        _this.callback();
      }, this.currInterval);
    }

    /**
     * stops the currently running timer
     */
  }, {
    key: "stopInterval",
    value: function stopInterval() {
      window.clearInterval(this.timerID);
    }

    /**
     * pauses the currently running timer
     */
  }, {
    key: "pauseInterval",
    value: function pauseInterval() {
      var now = Date.now();
      this.timeRemaining = this.currInterval - (now - this.startTime);
      this.stopInterval();
    }

    /**
     * resumes a 'paused' timer by setting a timeout for the amount of time remaining in previous interval then resetting the intervals..
     */
  }, {
    key: "resumeInterval",
    value: function resumeInterval() {
      var _this2 = this;
      this.timerID = window.setTimeout(function () {
        _this2.callback();
        _this2.startInterval();
      }, this.timeRemaining);
    }

    /**
     * sets a new interval timing.
     * @param time
     */
  }, {
    key: "setInterval",
    value: function setInterval(time) {
      this.stopInterval();
      this.currInterval = time;
    }
  }]);
}();
export default WDHCarouselTimer;